import React from "react";

import { useIntl } from "react-intl";

import TextWithInfo from "@app/component/typography/TextWithInfo";

import BaseHeader, { BaseHeaderProps } from "./BaseHeader";

const TeamsHeader: React.FC<BaseHeaderProps> = ({ displayName, ...otherProps }) => {
  const intl = useIntl();

  return (
    <BaseHeader
      displayName={
        <TextWithInfo
          info={intl.formatMessage({
            id: "grid.teamsHeader.description",
            defaultMessage:
              "If the owner of a record belongs to one or more teams, those team(s) are displayed here in this column.",
            description: "Description of grid teams header",
          })}
          placement="top"
        >
          {intl.formatMessage({
            id: "grid.teamsHeader.text",
            defaultMessage: "Team(s)",
            description: "Title of grid teams header",
          })}
        </TextWithInfo>
      }
      {...otherProps}
    />
  );
};

export default TeamsHeader;
